<template>
    <div id="admin-logs" class="dashwidget dashwidget-w-full">
        <div class="flex" style="justify-content: space-between">
            <div>
                <div class="grid-title">Notification Logs</div>
            </div>
            <div class="logs-search-container">
                <div>
                    <input
                        class="notifications-checkbox"
                        id="flagged-checkbox"
                        type="checkbox"
                        v-model="failedOnly"
                        @click="handleFailedOnlyToggle"
                    ><b class="red"> Failed</b> only
                </div>
                <div style="padding-left: 10px">
                    <VueCtkDateTimePicker
                        v-model="dateRange"
                        :custom-shortcuts='dataShortcuts'
                        :range="true"
                        id="notification-range"
                        color="#005288"
                        button-color="#005288"
                        formatted="YYYY-MM-DD"
                        format="YYYY-MM-DD"
                        :minDate="minDate"
                        :auto-close="true"
                        :no-button="true"
                        :only-date="true"
                        :no-label="true"
                        :no-clear-button="true"
                        input-size="sm"
                    />
                </div>
                <div style="margin-left: 10px">
                    <acclaro-input placeholder="Enter Email Name or Order ID"
                                   :v-model="searchTerm"
                                   class="notification-search"
                                   @input="this.searchTermInput"
                    />
                </div>
            </div>
        </div>

        <span v-if="logs.length">
          <div class="widgetsubtitle">
            <div id="othtab" class="widgettab log-table-cols">
                <div class="log-col-header">Name</div>
                <div class="log-col-header">Sent To</div>
                <div class="log-col-header">Status</div>
                <div class="log-col-header">Sent At</div>
                <div class="log-col-header">Order ID</div>
                <div class="log-col-header">Task ID</div>
                <div class="log-col-header">File Name</div>
            </div>
          </div>
          <div class="widgetcontent scrolling dashwidget-table-rows" style="height: auto;">
              <div class="widgettab">
                <div id="account-references-tbody">
                  <div :key="log.id"
                       class="grid log-table-cols"
                       v-for="log in this.logs">
                    <div class="log-cols">
                      <img
                          class="notification-type-icon clickable"
                          title="View Delivered Notification"
                          @click="showNotificationEmail(log.id)"
                          src="/images/notifications/view-email.svg"
                      />
                        {{ log.notifiable_name.replace(/^.*[\\\/]/, '') }}
                    </div>
                    <div class="log-cols">
                      <div>To: {{ log.to || '-' }}</div>
                      <div v-if="log.cc !== ''">CC: {{ log.cc }}</div>
                      <div v-else></div>
                      <div v-if="log.bcc !== ''">BCC: {{ log.bcc }}</div>
                      <div v-else></div>
                    </div>
                    <div class="log-cols">
                      <b :class="getColor(log)">{{ getStatus(log) }}</b>
                    </div>
                    <div class="log-cols">
                      <span>{{ log.time_ago || '-' }}</span>
                    </div>
                    <div class="log-cols">
                      <a target="_blank" :href="log.order_url">{{ log.order_id || '-' }}</a>
                    </div>
                    <div class="log-cols">
                      <a target="_blank" :href="log.task_url">{{ log.task_id || '-' }}</a>
                    </div>
                    <div class="log-cols">
                      {{ log.file_name || '-' }}
                    </div>
                </div>
              </div>
            </div>
          </div>

          <acclaro-pagination
              :show-first-page="handleFirst"
              :show-previous-page="handlePrevious"
              :show-next-page="handleNext"
              :show-last-page="handleLast"
              :pagination-details="paginationDetails"
          />
    </span>
        <div v-else>No logs found. Please adjust date range, search term and or failed filter.</div>
        <acclaro-modal v-if="showNotificationPreview" @close="showNotificationPreview = false">
            <div slot="header" class="notification-header">
                <!--        <div>To: {{this.getNotificationRecipients('to').join(', ')}}</div>-->
                <!--        <div>CC: {{this.getNotificationRecipients('cc').join(', ')}}</div>-->
            </div>
            <div slot="body" class="html-notification-container" @click.prevent v-html="notificationEmail"></div>
        </acclaro-modal>
    </div>
</template>

<script>
import PaginationDetailsModel from "../../../store/modules/models/PaginationDetailsModel";
import axios from "axios";
import AcclaroPagination from "../../AcclaroPagination/AcclaroPagination";
import AcclaroInput from "../../Micro-Components/Acclaro-Input/Acclaro-Input";
import AcclaroModal from './../../Modal/acclaro-modal.vue';

export default {
    mounted() {
        this.fetchLogs();
    },
    components: {
        AcclaroModal,
        AcclaroPagination,
        AcclaroInput,
    },
    data:
        function () {
            return {
                logs: [],
                dateRange: undefined,
                'dataShortcuts': [
                    {key: 'today', label: 'Today', value: '-day'},
                    {key: 'thisWeek', label: 'This week', value: 'isoWeek'},
                    {key: 'Month', label: 'Past month', value: '-month'},
                    {key: 'thisMonth', label: 'This month', value: 'month'},
                ],
                searchTerm: '',
                notificationEmail: '',
                showNotificationPreview: false,
                failedOnly: false,
                paginationDetails: (new PaginationDetailsModel(undefined,
                    undefined,
                    undefined,
                    {
                        'url': "",
                        'page': 1
                    },
                    {
                        'url': "",
                        'page': 1
                    },
                    {
                        'url': "",
                        'page': ""
                    },
                    {
                        'url': "",
                        'page': ""
                    },
                    {
                        'url': "",
                        'page': ""
                    })),
            };
        },
    watch: {
        dateRange() {
            this.fetchLogs()
        }
    },
    computed: {
        minDate() {
            let d = new Date();
            d.setMonth(d.getMonth() - 3);
            return d.toLocaleDateString();
        }
    },
    methods: {
        getColor(log) {
            if (log.status === 2) {
                return 'yellow';
            } else {
                return log.status === 1 ? 'green' : 'red';
            }
        },
        showNotificationEmail(log_id) {
            axios.get(`/web-email/html/${log_id}`).then((res) => {
                this.notificationEmail = `<span> ${res.data} </span>`;
                this.showNotificationPreview = true;
            });
        },
        getStatus(log) {
            if (log.status === 2) {
                return 'Skipped';
            } else {
                return log.status === 1 ? 'Success' : 'Failed';
            }
        },
        fetchLogs(requestUrl = null) {
            if (!requestUrl) {
                EventBus.$emit('loader:show');
                const url = new URL(window.location.origin + '/reports/notifications/data');
                url.searchParams.append("page", this.paginationDetails.currentPage.page);
                if (this.searchTerm) {
                    url.searchParams.append("search_term", this.searchTerm);
                }
                if (this.failedOnly) {
                    url.searchParams.append("filter_only_failed", 1);
                }
                if (this.dateRange) {
                    console.log(this.dateRange)
                    url.searchParams.append("start", this.dateRange.start);
                    url.searchParams.append("end", this.dateRange.end);
                }
                requestUrl = url.href;
            }
            axios.get(requestUrl)
                .then(res => {
                        const {
                            data,
                        } = res.data;

                        this.paginationDetails.nextPage = {
                            page: undefined, //unused
                            url: data.next_page_url
                        };
                        this.paginationDetails.currentPage = {
                            url: undefined, //unused
                            page: data.current_page
                        };
                        this.paginationDetails.firstPage = {
                            url: data.first_page_url,
                            page: 1
                        };
                        this.paginationDetails.lastPage = {
                            url: data.last_page_url,
                            page: data.last_page
                        };
                        this.paginationDetails.previousPage = {
                            url: data.prev_page_url,
                            page: undefined //unused
                        };
                        this.paginationDetails.to = data.to;
                        this.paginationDetails.total = data.total;
                        this.paginationDetails.from = data.from;
                        this.logs = data.data;
                        EventBus.$emit('loader:hide');
                    }
                ).catch((e) => {
                console.log(e);
            });
        },
        handleNext() {
            this.fetchLogs(this.paginationDetails.nextPage.url);
        },
        handleFirst() {
            this.fetchLogs(this.paginationDetails.firstPage.url);
        },
        handleLast() {
            this.fetchLogs(this.paginationDetails.lastPage.url);
        },
        handlePrevious() {
            this.fetchLogs(this.paginationDetails.previousPage.url);
        },
        handleFailedOnlyToggle() {
            this.failedOnly = !this.failedOnly;
            this.fetchLogs();
        },
        dateRangeInput(value) {
            this.searchTerm = value;
            if (value.length === 0 || value.length > 2) {
                this.fetchLogs();
            }
        },
        searchTermInput(value) {
            this.paginationDetails.currentPage = {
                url: undefined, //unused
                page: 1
            };
            this.searchTerm = value;
            if (value.length === 0 || value.length > 2) {
                this.fetchLogs();
            }
        }
    }
};


</script>

<style scoped>

#admin-logs {
    font-size: 13px;
}

.log-cols {
    padding: 9px;
    border-bottom: 1px solid #CCCCCC;
}

.log-col-header {
    padding: 0 8px;
}

.log-table-cols {
    display: grid;
    grid-template-columns: 1fr 2fr .5fr 0.5fr .5fr .5fr .5fr;
}

.red {
    color: darkred;
}

.green {
    color: darkgreen;
}

.yellow {
    color: goldenrod;
}

.logs-search-container {
    padding-bottom: 10px;
    display: inline-flex;
    align-items: flex-end;
}

.notification-search {
    height: 36px;
}

</style>
